"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgList(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 -4 18 24" }, props),
        React.createElement("path", { d: "M20 0a1 1 0 011 1v14a1 1 0 01-1 1H4a1 1 0 01-1-1V1a1 1 0 011-1zm-2.066 7H6.066C5.477 7 5 7.448 5 8s.477 1 1.066 1h11.868C18.523 9 19 8.552 19 8s-.477-1-1.066-1zm0-4H6.066C5.477 3 5 3.448 5 4s.477 1 1.066 1h11.868C18.523 5 19 4.552 19 4s-.477-1-1.066-1z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('List')(SvgList);
//# sourceMappingURL=List.js.map